import { CreatorData } from "@/types/creatorData";

/**
 * Hook to extract display name and image from a creator object.
 * Logic extracted from app/page.tsx
 */
/**
 * Helper to extract display name and image from a creator object.
 * Pure function safe to use in loops or non-component contexts.
 */
export function getCreatorDisplayInfo(creatorData?: CreatorData | null) {
  let creatorName = "Unknown";
  let creatorImage: string | undefined = undefined;

  if (creatorData) {
    // Priority: 
    // 1. Top level: displayName > name > combined names
    // 2. Profile level: displayName > name > combined names
    // 3. Username

    // Helper to build name from first/last
    const getFullName = (first?: string, last?: string) => {
      if (first && last) return `${first} ${last}`;
      return first || "";
    };

    const topName = creatorData.displayName || creatorData.name || getFullName(creatorData.firstName, creatorData.lastName);
    const profileName = creatorData.profile?.displayName || creatorData.profile?.name || getFullName(creatorData.profile?.firstName, creatorData.profile?.lastName);

    if (topName) {
      creatorName = topName;
    } else if (profileName) {
      creatorName = profileName;
    } else if (creatorData.username) {
      creatorName = creatorData.username;
    }

    creatorImage = creatorData.avatar || creatorData.profile?.avatar;
  }

  return { creatorName, creatorImage };
}

/**
 * Hook to extract display name and image from a creator object.
 */
export function useCreatorDisplay(creator?: CreatorData | null, currentUser?: CreatorData | null) {
  const creatorData = creator || currentUser;
  return getCreatorDisplayInfo(creatorData);
}
